// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { XdlAccordion } from "@hardwoods/App/Widgets/DesignSystem/components/XdlAccordion";
import { XdlBreadcrumbs } from "@hardwoods/App/Widgets/DesignSystem/components/XdlBreadcrumbs";
import XdlButton from "@hardwoods/App/Widgets/DesignSystem/components/XdlButton";
import { XdlColors } from "@hardwoods/App/Widgets/DesignSystem/components/XdlColors";
import {
    XdlCheckBox,
    XdlDatePicker,
    XdlDynamicDropdown,
    XdlList,
    XdlRadio,
    XdlSelect,
    XdlTextArea,
    XdlTextField,
} from "@hardwoods/App/Widgets/DesignSystem/components/XdlForm";
import { XdlIcons } from "@hardwoods/App/Widgets/DesignSystem/components/XdlIcons";
import { XdlLinks } from "@hardwoods/App/Widgets/DesignSystem/components/XdlLinks";
import { XdlModal } from "@hardwoods/App/Widgets/DesignSystem/components/XdlModal";
import { XdlNotify } from "@hardwoods/App/Widgets/DesignSystem/components/XdlNotify";
import { XdlTable } from "@hardwoods/App/Widgets/DesignSystem/components/XdlTable";
import { XdlToast } from "@hardwoods/App/Widgets/DesignSystem/components/XdlToast";
import { XdlTooltip } from "@hardwoods/App/Widgets/DesignSystem/components/XdlTooltip";
import { generateDynamicGridItemStyle } from "@hardwoods/App/Widgets/DesignSystem/DesignSystem.utils";
import DummyPaginatedTable from "@hardwoods/App/Widgets/DesignSystem/DummyPaginatedTable";
import { capitalize } from "@hardwoods/XDL/Utilities";
import FieldDefinition from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Tab from "@insite/mobius/Tab";
import TabGroup from "@insite/mobius/TabGroup/TabGroup";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC } from "react";
import { css } from "styled-components";

export const SectionContainer: FC<any> = ({ children }) => {
    return (
        <section style={{ display: "flex", width: "100%" }}>
            <GridContainer gap={50}>{children}</GridContainer>
        </section>
    );
};

export const SectionTitle: FC<{ title: string }> = ({ title }) => {
    const style: TypographyPresentationProps = {
        variant: "h3",
        size: 26,
        css: css`
            font-weight: bold;
            width: 100%;
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    };

    return (
        <GridItem {...generateDynamicGridItemStyle(1)}>
            <Typography {...style}>{capitalize(title)}</Typography>
        </GridItem>
    );
};

const XdlTab = () => {
    return (
        <TabGroup>
            <Tab headline="Colors" tabKey="Colors">
                <SectionContainer>
                    <SectionTitle title="Colors" />
                    <XdlColors />
                </SectionContainer>
            </Tab>
            <Tab headline="Buttons" tabKey="Buttons22">
                <SectionContainer>
                    <XdlButton />
                </SectionContainer>
            </Tab>
            <Tab headline="Form" tabKey="Form">
                <SectionContainer>
                    <SectionTitle title="List" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <XdlList />
                    </GridItem>

                    <SectionTitle title="DatePicker" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <XdlDatePicker />
                    </GridItem>

                    <SectionTitle title="CheckBox & Radio" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <GridContainer gap={20}>
                            <GridItem {...generateDynamicGridItemStyle(2, 1)}>
                                <XdlCheckBox />
                            </GridItem>
                            <GridItem {...generateDynamicGridItemStyle(2, 1)}>
                                <XdlRadio />
                            </GridItem>
                        </GridContainer>
                    </GridItem>

                    <SectionTitle title="TextFiled" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <XdlTextField />
                    </GridItem>

                    <SectionTitle title="TextArea" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <XdlTextArea />
                    </GridItem>

                    <SectionTitle title="Select" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <XdlSelect />
                    </GridItem>

                    <SectionTitle title="Dynamic DropDown" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <XdlDynamicDropdown />
                    </GridItem>
                </SectionContainer>
            </Tab>
            <Tab headline="Icons" tabKey="Icons">
                <SectionContainer>
                    <SectionTitle title="Icons" />
                    <XdlIcons />
                </SectionContainer>
            </Tab>
            <Tab headline="Table" tabKey="Table">
                <SectionContainer>
                    <SectionTitle title="Tables" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <XdlTable />
                    </GridItem>
                </SectionContainer>
            </Tab>
            <Tab headline="Tooltip" tabKey="Tooltip">
                <SectionContainer>
                    <SectionTitle title="Tooltip" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <XdlTooltip />
                    </GridItem>
                </SectionContainer>
            </Tab>
            <Tab headline="Accordions" tabKey="Accordions">
                <SectionContainer>
                    <SectionTitle title="Accordions" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        we have issue here!
                        <XdlAccordion />
                    </GridItem>
                </SectionContainer>
            </Tab>
            <Tab headline="Toast" tabKey="Toast">
                <SectionContainer>
                    <SectionTitle title="Toast / Notification" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <XdlToast />
                    </GridItem>
                </SectionContainer>
            </Tab>
            <Tab headline="Notify" tabKey="Notify">
                <SectionContainer>
                    <SectionTitle title="Notify - static message" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <XdlNotify />
                    </GridItem>
                </SectionContainer>
            </Tab>
            <Tab headline="Breadcrumbs" tabKey="Breadcrumbs">
                <SectionContainer>
                    <SectionTitle title="Breadcrumbs" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <XdlBreadcrumbs />
                    </GridItem>
                </SectionContainer>
            </Tab>
            <Tab headline="Links" tabKey="Links">
                <SectionContainer>
                    <SectionTitle title="Links" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <XdlLinks />
                    </GridItem>
                </SectionContainer>
            </Tab>
            <Tab headline="Modal" tabKey="Modal">
                <SectionContainer>
                    <SectionTitle title="Modal" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <XdlModal />
                    </GridItem>
                </SectionContainer>
            </Tab>
            <Tab headline="Pagination" tabKey="Pagination">
                <SectionContainer>
                    <SectionTitle title="Pagination" />
                    <GridItem {...generateDynamicGridItemStyle(1)}>
                        <DummyPaginatedTable />
                    </GridItem>
                </SectionContainer>
            </Tab>
        </TabGroup>
    );
};

const DesignSystemWidget = () => {
    return <XdlTab />;
};

const widgetModule: WidgetModule<FieldDefinition> = {
    component: DesignSystemWidget,
    definition: {
        group: "Xngage Custom" as any,
    },
};

export default widgetModule;
